import { render, staticRenderFns } from "./DashboardPnet.vue?vue&type=template&id=7773d35c&scoped=true"
import script from "./DashboardPnet.vue?vue&type=script&lang=js"
export * from "./DashboardPnet.vue?vue&type=script&lang=js"
import style0 from "./DashboardPnet.vue?vue&type=style&index=0&id=7773d35c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7773d35c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7773d35c')) {
      api.createRecord('7773d35c', component.options)
    } else {
      api.reload('7773d35c', component.options)
    }
    module.hot.accept("./DashboardPnet.vue?vue&type=template&id=7773d35c&scoped=true", function () {
      api.rerender('7773d35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardPnet.vue"
export default component.exports